import React, { Component } from "react";
import { authOperations } from './state'
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, Container, Card, InputGroup } from 'react-bootstrap';
import { withRouter, Redirect } from "react-router-dom";
import '../../../includes/custom/css/login.css';
import { bindActionCreators } from 'redux'
import { FaUser, FaKey } from 'react-icons/fa'
import StoreHeader from "../../components/StoreHeader";
import { STORE_NEW_ADVERTISEMENT_ROUTE } from "./routes";
import { EMPTY_STRING, EMAIL_LENGTH, PASSWORD_LENGTH, LOGIN, USERNAME, PASSWORD, NOTIF_ERROR, ERROR } from '../../../utils/constants'
import { SideNotification } from '../../../utils/common';
import { INCORRECT_CREDENTIALS, MSG_CONTACT_ADMIN } from '../../../utils/messages';



class StoreLoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      logged: false,
      errorMessage: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateForm() {
    return EMAIL_LENGTH < this.state.username.length && PASSWORD_LENGTH < this.state.password.length;
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ errorMessage: EMPTY_STRING }, () => {
      this.props.loginStore(this.state.username, this.state.password)
        .then((result) => {
          if (undefined === result) {
            SideNotification(NOTIF_ERROR, MSG_CONTACT_ADMIN)
          } else {
            if (ERROR === result.status) {
              this.setState({ errorMessage: INCORRECT_CREDENTIALS });
            }
          }
        });
    });
  }

  render() {
    // Change the redirect to the main page of your app
    if (this.props.isStoreAuthenticated) {
      return <Redirect to={STORE_NEW_ADVERTISEMENT_ROUTE} />;
    }

    return (
      <div>
        <StoreHeader isStoreAuthenticated={this.props.isStoreAuthenticated} />

        <Container className="login-container">
          <Card className="login-card">
            <center><h2>{LOGIN}</h2></center>
            <center><h5 className="login-errors">{this.state.errorMessage}</h5></center>
            <form onSubmit={this.handleSubmit}>
              <FormGroup controlId="username">
                <FormLabel>{USERNAME}</FormLabel>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text><FaUser /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    size="lg"
                    autoFocus
                    autoComplete="off"
                    type="email"
                    value={this.state.username}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup controlId="password">
                <FormLabel>{PASSWORD}</FormLabel>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text><FaKey /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    size="lg"
                    autoComplete="off"
                    value={this.state.password}
                    onChange={this.handleChange}
                    type="password"
                  />
                </InputGroup>
              </FormGroup>
              <Button
                block
                size="lg"
                disabled={!this.validateForm()}
                onClick={this.handleSubmit}
                type="submit"
                className="login-btn"
              >
                {LOGIN}
              </Button>
            </form>
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isStoreAuthenticated: state.auth.isStoreAuthenticated,
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    loginStore: authOperations.loginStore,
    logoutStore: authOperations.logoutStore
  },
  dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StoreLoginScreen));